import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import InitialProblemForm from "../InitalProblem";
import Wizard from "../Wizard/Index";
import { useCustDiagStore } from "../../contexts/RootStoreProvider";
import { observer } from "mobx-react-lite";

const MainCardContainer = (props: any) => {
  const custDiagStore = useCustDiagStore();

  return (
    
    <Grid sx={{ m: 2  }}>
      {custDiagStore.currentStage === 1 ? <InitialProblemForm /> : <Wizard />}
    </Grid>
  );
};

MainCardContainer.propTypes = {};

export default observer(MainCardContainer);
